import React from 'react'
import "./Advers.css";
import adversImage from "../../assets/advers.png";
import arrowIcon from "../../assets/cross-arrow.svg";

export default function Advers() {
    return (
        <section className='advers-section'>
            <div className="container">
                <div className="advers">
                    <img className='advers-image' src={adversImage} alt="" />
                    <a href="https://apps.apple.com/us/app/commito/id6642675101" target='_blank' rel="noreferrer" className="custom-button">
                        <span className="text">
                            <strong>Free</strong> Download
                        </span>
                        <img src={arrowIcon} alt="Arrow Icon" className="arrow-icon" />
                    </a>
                </div>
            </div>
        </section>
    )
}
